
import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Modal } from 'antd'
import PopupManager from '../../managers/PopupManager';
import { PlusCircleFilled } from '@ant-design/icons';
import { Container } from 'react-smooth-dnd';
import DropZoneContainer from './DropZoneContainer';
import PermissionManager from '../../managers/PermissionManager';

const PlaylistNotLinkView = (props) => {
    const { onCreatePlaylistClick, onPlaylistCreated = () => { }, noDropCreateMessage = "", allowDropCreate = false } = props;

    const checkPermission = () => {
        return new Promise((resolve, reject) => {

            if (allowDropCreate) {

                resolve()
            }
            else {
                if (noDropCreateMessage !== "")
                    Modal.warning({ content: noDropCreateMessage })

                reject();
            }
        })
    }
    return (
        <DropZoneContainer behaviour="drop-zone" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", minHeight: "500px" }} groupName="file" onDrop={() => {

            if (allowDropCreate) {

                checkPermission().then(() => {

                    PopupManager.launchCreatePlaylistPopup((playlistID) => {
                        onPlaylistCreated(playlistID);
                    })
                })

            }
            else {
                if (noDropCreateMessage !== "")
                    Modal.warning({ content: noDropCreateMessage })
            }
        }}>
            <Row style={{ width: "600px" }}>
                <Col className="center-content" span={10}>
                    <Row>

                        <Col span={24} style={{ fontSize: 38, fontWeight: 500, lineHeight: "42px", width: "250px", margin: "0 0 30px 0" }}>

                            No playlist connected to this channel
                    </Col>
                        <Col span={24} style={{ fontSize: 16, fontWeight: 400, lineHeight: "18px", width: "250px", margin: "0 0 30px 0" }}>
                            Choose from an exiting playlist from the top-right dropdown or, as easily, create a new one
                    </Col>
                        <Col>
                            <Button size="medium" style={{ margin: "8px" }} onClick={() => {
                                checkPermission().then(() => {
                                    PopupManager.launchCreatePlaylistPopup((playlistData) => {
                                        onPlaylistCreated(playlistData);
                                    })
                                })


                            }} type="primary" icon={<PlusCircleFilled></PlusCircleFilled>}>New Playlist</Button>
                        </Col>
                    </Row>
                </Col>
                <Col className="center-content" span={14}>
                    <img style={{ width: "100%", objectFit: "contain" }} src="/cms/assets/svgs/decorations/decorate_playlistnotlink.svg"></img>
                </Col>
            </Row >
        </DropZoneContainer>
    )
}

export default PlaylistNotLinkView